/**
 * GiftDetailPresenter
 * --
 */
import React from 'react';

const GiftDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>GiftDetailPresenter</p>
    </div>
  );
};

export default GiftDetailPresenter;
